"use strict";

export function GoUrl(that, path, parm) {
	goTempUrl(that, path, parm);
}

// 验证 是不是json
export function isJson(str) {
	let flag = false;
	if (typeof str == 'string') {
		try {
			var obj = JSON.parse(str);
			if (typeof obj == 'object' && obj) {
				flag = true;
			}

		} catch (e) {
			console.log('error：' + str + '!!!' + e);

		}
	}
	return flag;
}


// 验证 是不是电脑端
export function isPC(that) {
  
  let sys_now = ''
  let ua = window.navigator.userAgent.toLowerCase();
  console.log(ua);
  
  if (ua.match(/MicroMessenger/i) == 'micromessenger') { //判断微信
  	sys_now = 'weixin';
  } else {
  	var bIsIpad = ua.match(/ipad/i) == "ipad";
  	var bIsIphoneOs = ua.match(/iphone os/i) == "iphone os";
  	var bIsMidp = ua.match(/midp/i) == "midp";
  	var bIsUc7 = ua.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  	var bIsUc = ua.match(/ucweb/i) == "ucweb";
  	var bIsAndroid = ua.match(/android/i) == "android";
  	var bIsCE = ua.match(/windows ce/i) == "windows ce";
  	var bIsWM = ua.match(/windows mobile/i) == "windows mobile";
  
  	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
  		sys_now = 'phone';
  	} else {
  		sys_now = 'pc';
  	}
  }
  
  if(sys_now!='pc'){
  	
	let o={};
	o.key='msg';
	o.val='请在电脑端打开软件!'
	
  	that.$router.push({
  	  path: "/error",
  	  query: o
  	}).catch(err => err);
	return
  }
  
}

export function ReplaceAll(str,not_val,ok_val){
  var reg = new RegExp( not_val , "g" )
  var newstr = str.replace( reg , ok_val );
  return newstr;
}

export function newgroup(array) {
	let new_arr = [];
	// for(let i=0;i<array.length;i++){
	// 	new_arr.push(array[i]);
	// }

	// let str='';
	// str=array.join('-');
	// new_arr = str.split("-"); // 新数组

	new_arr = [...array];

	return new_arr;
}


export function GetRandom() {
	var chars = [
		"0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G",
		"H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X",
		"Y", "Z"
	];
	var maxLength = 4;
	var randomAccount = '';
	for (var i = 0; i < maxLength; i++) {
		var id = Math.ceil(Math.random() * 35);
		randomAccount += chars[id];
	}
	return randomAccount;
}

// 默认情况下jquery在处理textArea中文本时是会忽略掉回车符的，为了保留回车符选择使用<pre></pre>标签嵌套textArea中的内容，同时替换掉‘<’和'>'避免js注入。
// 不行测试失败 还是不能保留
export function CheckTextArea(value) {
	// var value = $("#textArea").val(); //获取textArea中的文字
	value = value.replace(/</g, "&lt;").replace(/>/g, "&gt;"); //替换'<'，'>'
	// var html = "<pre>" + value + "</pre>"; //创建pre元素
	// $(html).appendTo($("#result")); //添加的目标位置
	return value;
}

export function CheckInputData(value) {
	// var value = $("#textArea").val(); //获取textArea中的文字
	value = value.replace(" ", "");
	value = value.replace(/</g, "&lt;").replace(/>/g, "&gt;"); //替换'<'，'>'
	// var html = "<pre>" + value + "</pre>"; //创建pre元素
	// $(html).appendTo($("#result")); //添加的目标位置
	return value;
}

/*
给字符串增加 空格
tm 增加的字符
num 每几位
*/
export function AddStringSomething(str, tm, num) {
	console.log("前" + tm + "   " + num);
	if (tm == undefined || String(tm) == "null" || String(tm).length == 0) {
		tm = " ";
	}
	if (num == undefined || Number(num) == 0) {
		num = 4;
	}
	console.log("后" + tm + "   " + num);
	var newstr = "";
	var oldlen = 0;
	oldlen = str.length;
	while (oldlen > 0) {
		if (oldlen > num) {
			newstr = newstr + str.substr(0, num) + tm;
			str = str.substr(num, str.length - num);
			oldlen = str.length;
		} else {
			newstr = newstr + str + tm;
			oldlen = 0;
		}
	}
	return newstr;
}

/**
 * 邮箱验证 */
export function checkStringByForm(value, type) {
	// console.log("格式校验 " + value);
	var flag = false;
	var reg = "";
	switch (type) {
		case "email":
			// reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/; //正则表达式
			// reg = /^[A-Za-zd]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
			// reg = /^[A-Za-zd]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
			reg = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/;
			break;
		case "zuoji":
			// 验证规则：座机。
			reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
			break;
		case "phone":
			// 验证规则：11位数字，以1开头。
			reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
			break;
		case "phone2":
			reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
			break;
		case "user":
			// 验证规则：字母、数字、下划线组成，字母开头，4-16位。
			reg = /^[a-zA-z]\w{3,15}$/;
			break;
		case "Eng":
			// 验证规则：只能是字母下划线开始。
			reg = /^[a-zA-Z_]*$/;
			break;
		case "Eng123":
			// 验证规则：只能是字母下划线开始。
			reg = /^[a-zA-Z][a-zA-Z0-9_]*$/;
			break;
		case "china":
			// 汉字
			reg = /^[\u4e00-\u9fa5]$/;
		default:
			flag = false;
			break;
	}
	// console.log("校验前" + flag );

	if (value != "" && reg != "") {
		flag = reg.test(value);
	}
	// console.log(reg);
	// console.log("校验后" + flag );
	// console.log(reg);
	// console.log("校验结果" + flag + "  " + reg.test(value));
	return flag;
}


// 指定月份天数
// 由于JavaScript中day的范围为1~31中的值，所以当设为0时，
// 会向前 一天，也即表示上个月的最后一天。
export function daysFormMonth(datetime) {
  let y = 0,
    m = 0,
    d = 0;
  //
  // console.log(datetime);
  let first_day = '';
  first_day = datetime.substring(0, 10);
  // console.log('='+first_day);
  // console.log('='+second_time);
  y = Number(first_day.substring(0, 4));
  m = Number(first_day.substring(5, 7));

  if (Number(m) == 12) {
    m = 0;
    y += 1;
  }

  console.log('y=' + y + ' m=' + m);

  var date = new Date();
  var days = new Date(y, m, 0);

  return days.getDate();
}

// 删除特殊字符串
/* 网址URL中特殊字符转义编码

空格   -    %20	" -    %22		#     -    %23 	%     -    %25
&     -    %26	(     -    %28	)     -    %29 	+     -    %2B
,     -    %2C	/     -    %2F	:     -    %3A	;     -    %3B
<     -    %3C	=     -    %3D	>     -    %3E	?     -    %3F
@     -    %40	\     -    %5C	|     -    %7C 

*/
export function Word_Right_Delete(str) {
	str = String(str);
	str = str.replace(' ', "%20");
	str = str.replace(/\"/g, "%22");
	str = str.replace(/\#/g, "%23");	
	str = str.replace(/\%/g, "%25");
	str = str.replace(/\&/g, "%26");
	str = str.replace(/\(/g, "%28");
	str = str.replace(/\)/g, "%29");
	str = str.replace(/\+/g, "%2B");
	str = str.replace(/\,/g, "%2C");
	str = str.replace(/\//g, "%2F");
	str = str.replace(/\:/g, "%3A");
	str = str.replace(/\;/g, "%3B");
	str = str.replace(/\@/g, "%40");
	str = str.replace(/\=/g, "%3D");
	str = str.replace(/\?/g, "%3F");
	str = str.replace(/\./g, "%2E");
	str = str.replace(/\\/g, "%5C");
	str = str.replace(/\|/g, "%7C");



	// str = str.replace('^', '');  不好使用，只去掉一个
	var t = str.split("^");
	str = t.join("");
	str = str.replace(' ', '');
	// str = str.replace(/\n|\r|(\r\n)|(\u0085)|(\u2028)|(\u2029)/g, '');
	// add 2019-06-14 去掉,影响查询语句
	// str = str.replace('{', '');
	// str = str.replace('}', '');
	// str = str.replace('(', '');
	// str = str.replace(')', '');
	// console.log(str);
	return str;
}

export function RandomColor() {
	var r = Math.floor(Math.random() * 256);

	var g = Math.floor(Math.random() * 256);

	var b = Math.floor(Math.random() * 256);

	return "rgb(" + r + ',' + g + ',' + b + ")"; //所有方法的拼接都可以用ES6新特性`其他字符串{$变量名}`替换

}


function goTempUrl(that, path, parm) {
	// this.$refs.childrenmode.loadselect();

	// this.$router.push({
	//   name: 'compute',
	//   query: {
	//   t: +new Date() //保证每次点击路由的query项都是不一样的，确保会重新刷新view
	//   }});
	// console.log(this.$refs);
	var chars = [
		"0",
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9",
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z"
	];
	var maxLength = 4;
	var paramsAccount = "";
	for (var i = 0; i < maxLength; i++) {
		var id = Math.ceil(Math.random() * 35);
		paramsAccount += chars[id];
	}

	// res 为随机字符串,下面是跳转：
	// console.log('路径=' + path);
	// console.log(' 参数=', parm);

	if (Number(parm) > 0) {
		let o = {};
		o.key = 'sheet_no';
		o.val = parm;
		parm = o;
	}


	if (path === undefined || path == null || String(path) == 'undefined') {

		that.$router.push({
			path: "/home",
			query: parm
		}).catch(err => err);

		// that.$router.push({
		// 	name: "home",
		// 	params: parm
		// }).catch(err => err);

	} else {
		that.$router.push({
			path: "/" + path,
			query: parm
		}).catch(err => err);

		// that.$router.push({
		// 	name: path,
		// 	params: parm
		// }).catch(err => err);
	}
}

// 时间相关
export function dateFormat(fmt, date) {
	//author: meizz
	var o = {
		'M+': date.getMonth() + 1, //月份
		'd+': date.getDate(), //日
		'h+': date.getHours(), //小时
		'm+': date.getMinutes(), //分
		's+': date.getSeconds(), //秒
		'q+': Math.floor((date.getMonth() + 3) / 3), //季度
		S: date.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp('(' + k + ')').test(fmt))
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
	return fmt;
}


export function dateFormatbyChina(chinaStandard) {
  // console.log(chinaStandard);
  if (typeof(chinaStandard) === 'undefined' || chinaStandard == '') {

    return '';
  }

  let time = '';
  if (chinaStandard.length == 8) {
    // console.log('8位日期转换===========')
    // console.log(chinaStandard);
    time = chinaStandard.substring(0, 4) + '-' + chinaStandard.substring(4, 6) + '-' + chinaStandard.substring(6, 7);
  } else {
    var date = new Date(chinaStandard);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    var ss = date.getSeconds();
    ss = ss < 10 ? ('0' + ss) : ss;
    time = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + ss; //这里如果不需要小时 分  后边的可以不需要拼接
  }
  // let time = y + '-' + m + '-' + d; //这里如果不需要小时 分  后边的可以不需要拼接
  return time;
}

export function dateFormatEasybyChina(chinaStandard) {


	let time = '';
	if (chinaStandard.length == 8) {
		console.log('8位日期转换')
		console.log(chinaStandard);
		time = chinaStandard.substring(0, 4) + '-' + chinaStandard.substring(4, 6) + '-' + chinaStandard.substring(6,
			7);
	} else {
		var date = new Date(chinaStandard);
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		m = m < 10 ? ('0' + m) : m;
		var d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		time = y + '-' + m + '-' + d;
	}

	return time;
}

export function getNowDateTime() {
	var date = new Date();
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	var h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	var minute = date.getMinutes();
	minute = minute < 10 ? ('0' + minute) : minute;
	var ss = date.getSeconds();
	ss = ss < 10 ? ('0' + ss) : ss;
	let time = y + '-' + m + '-' + d + '-' + h + '-' + minute + '-' + ss;
	return time;
}

export function dateFormatToChina(first_day, second_time) {
	if (typeof(first_day) == 'undefined' || first_day == '') {
		var date = new Date();
		var ty = date.getFullYear();
		var tm = date.getMonth() + 1;
		tm = tm < 10 ? ('0' + tm) : tm;
		var td = date.getDate();
		td = td < 10 ? ('0' + td) : td;
		first_day = ty + '-' + tm + '-' + td;
	}
	// console.log(first_day);
	let y = '',
		m = '',
		d = '',
		h = '',
		mm = '',
		ss = '';
	y = first_day.substring(0, 4);
	m = first_day.substring(5, 7);
	d = first_day.substring(8, 10);
	// console.log('年=' + y + ' 月=' + m + ' 日=' + d);
	let arr = second_time.split(':');
	if (arr.length > 0) {
		h = arr[0];
		mm = arr[1];
		ss = arr[2];
	}
	return new Date(y, m, d, h, mm, ss);
}

export function dateFormatToChina2(datetime) {
	let y = '',
		m = '',
		d = '',
		h = '',
		mm = '',
		ss = '';

	// console.log(datetime);
	let first_day = '',
		second_time = '';
	first_day = datetime.substring(0, 10);
	second_time = datetime.substring(11, 19);
	// console.log('='+first_day);
	// console.log('='+second_time);
	y = first_day.substring(0, 4);
	m = first_day.substring(5, 7);
	d = first_day.substring(8, 10);
	// console.log('年=' + y + ' 月=' + m + ' 日=' + d);
	let arr = second_time.split(':');
	if (arr.length > 0) {
		h = arr[0];
		mm = arr[1];
		ss = arr[2];
	}
	return new Date(y, m, d, h, mm, ss);
}

/* 生成唯一ID */
export function UUID() {
	var d = new Date().getTime();
	if (window.performance && typeof window.performance.now === "function") {
		d += performance.now(); //use high-precision timer if available
	}
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
	return uuid.toUpperCase();
}


function s2ab(s) {
	// 字符串转字符流
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);
	for (var i = 0; i !== s.length; ++i) {
		view[i] = s.charCodeAt(i) & 0xff;
	}
	return buf;
}

function getCharCol(n) {
	// 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
	let s = "";
	let m = 0;
	while (n > 0) {
		m = (n % 26) + 1;
		s = String.fromCharCode(m + 64) + s;
		n = (n - m) / 26;
	}
	return s;
}

function fixdata(data) {
	// 文件流转BinaryString
	var o = "";
	var l = 0;
	var w = 10240;
	for (; l < data.byteLength / w; ++l) {
		o += String.fromCharCode.apply(
			null,
			new Uint8Array(data.slice(l * w, l * w + w))
		);
	}
	o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
	return o;
}

function countTime() {
	//获取当前时间
	var date = new Date();
	var now = date.getTime();
	//设置截止时间
	// var str="2019/02/28 00:00:00";
	var str = lastdate;
	var endDate = new Date(str);
	var end = endDate.getTime();

	//时间差
	var leftTime = end - now;
	//定义变量 d,h,m,s保存倒计时的时间
	var d, h, m, s;
	if (leftTime >= 0) {
		d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
		h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
		m = Math.floor((leftTime / 1000 / 60) % 60);
		s = Math.floor((leftTime / 1000) % 60);
	}
	//将倒计时赋值到div中
	document.getElementById('_d').innerHTML = d + '天';
	document.getElementById('_h').innerHTML = h + '时';
	document.getElementById('_m').innerHTML = m + '分';
	document.getElementById('_s').innerHTML = s + '秒';
	//递归每秒调用countTime方法，显示动态时间效果
	// setTimeout(countTime, 1000);
}

function getNowAddTreeFormatDate() {
	var date = new Date();
	date.setDate(date.getDate() + 3); //获取3天后的日期
	var seperator1 = '-';
	var seperator2 = ':';
	var month = date.getMonth() + 1;
	var monthStr;
	var day = date.getDate();
	var dayStr;
	if (month >= 1 && month <= 9) {
		monthStr = '0' + month.toString();
	} else {
		monthStr = month.toString();
	}
	if (day >= 0 && day <= 9) {
		dayStr = '0' + day.toString();
	} else {
		dayStr = day.toString();
	}
	// var currentdate = date.toISOString(); //date.getFullYear() + seperator1 + month + seperator1 + dayStr + 'T00:00:00+08:00'
	var currentdate = date.toDateString();
	console.log('三天后日期 ' + currentdate);
	return currentdate;
}



function StrReplaceAll(str,not_val,ok_val){
  // var reg = new RegExp( not_val , "g" )
  // var newstr = str.replace( reg , ok_val );
  
  var t = str.split(not_val);
  var newstr = t.join(ok_val);
  
  return newstr;
}

export function ChangeSpecial(str) {
	str = String(str);
	
	let arr=[
		{"key":" ","val":"%20"},
		{"key":'\"',"val":"%22"},
		{"key":"\#","val":"%23"},
		// {"key":"%","val":"%25"},
		{"key":"\&","val":"%26"},
		// {"key":"\(","val":"%28"},
		// {"key":"\)","val":"%29"},
		{"key":"\+","val":"%2B"},
		{"key":"\,","val":"%2C"},
		{"key":"\/","val":"%2F"},
		{"key":"\:","val":"%3A"},
		{"key":"\;","val":"%3B"},
		{"key":"\@","val":"%40"},
		{"key":"\=","val":"%3D"},
		{"key":"\?","val":"%3F"},
		{"key":"\.","val":"%2E"},
		{"key":"\\","val":"%5C"},
		{"key":"\|","val":"%7C"},
		{"key":"\r\n","val":"<br%2F>"},
		{"key":"\r","val":"<br%2F>"},
		{"key":"\n","val":"<br%2F>"},
		{"key":"\r\n","val":"<br%2F>"},
		{"key":"\r\n","val":"<br/>"}];
	
	for(let i=0;i<arr.length;i++){
		if(str.indexOf(arr[i].val)>=0){	
			str=StrReplaceAll(str,arr[i].val,arr[i].key);
		}
	}
	
	// str=StrReplaceAll(str,'<br%2F>','\\r\\n');
		
	return str;
}


export function DeleteSpecial(str) {
	str = String(str);
	
	let arr=[
		{"key":" "}];
	
	for(let i=0;i<arr.length;i++){
		if(str.indexOf(arr[i].key)>=0){	
			str=StrReplaceAll(str,arr[i].key,'');
		}
	}
	
	// str=StrReplaceAll(str,'<br%2F>','\\r\\n');
		
	return str;
}

export function BackSpecial(str) {
	str = String(str);
	// console.log(str);
	let arr=[
		{"key":" ","val":"%20"},
		{"key":'\"',"val":"%22"},
		{"key":"\#","val":"%23"},
		// {"key":"%","val":"%25"},
		{"key":"\&","val":"%26"},
		// {"key":"\(","val":"%28"},
		// {"key":"\)","val":"%29"},
		{"key":"\+","val":"%2B"},
		{"key":"\,","val":"%2C"},
		{"key":"\/","val":"%2F"},
		{"key":"\:","val":"%3A"},
		{"key":"\;","val":"%3B"},
		{"key":"\@","val":"%40"},
		{"key":"\=","val":"%3D"},
		{"key":"\?","val":"%3F"},
		{"key":"\.","val":"%2E"},
		{"key":"\\","val":"%5C"},
		{"key":"\|","val":"%7C"},
		{"key":"\r\n","val":"<br%2F>"},
		{"key":"\r","val":"<br%2F>"},
		{"key":"\n","val":"<br%2F>"},
		{"key":"\t","val":"%20%20%20%20"},
		{
			"key": "\r\n",
			"val": "<br/>"
		}];
	
	for(let i=0;i<arr.length;i++){
		if(str.indexOf(arr[i].key)>=0){	
			console.log('替换字符='+arr[i].key)
			str=StrReplaceAll(str,arr[i].key,arr[i].val);
		}
	}
	// str = str.replace(' ', "%20");
	// str = str.replace(/\"/g, "%22");
	// str = str.replace(/\#/g, "%23");	
	// str = str.replace(/\%/g, "%25");
	// str = str.replace(/\&/g, "%26");
	// str = str.replace(/\(/g, "%28");
	// str = str.replace(/\)/g, "%29");
	// str = str.replace(/\+/g, "%2B");
	// str = str.replace(/\,/g, "%2C");
	// str = str.replace(/\//g, "%2F");
	// str = str.replace(/\:/g, "%3A");
	// str = str.replace(/\;/g, "%3B");
	// str = str.replace(/\@/g, "%40");
	// str = str.replace(/\=/g, "%3D");
	// str = str.replace(/\?/g, "%3F");
	// str = str.replace(/\./g, "%2E");
	// str = str.replace(/\\/g, "%5C");
	// str = str.replace(/\|/g, "%7C");
	// str=str.replace(/\r\n/g, "<br%2F>").replace(/\n/g, "<br%2F>");
	// str=StrReplaceAll(str,'\r\n','<br%2F>');
	// str=StrReplaceAll(str,'\n','<br%2F>');

	//" - %22
	return str;
}


//检测 校验 json 格式 特殊部分转换
export function JsonCheck(str) {
	str = String(str);
	
	let arr=[
		{"key":" ","val":"%20"},
		// {"key":'\"',"val":"%22"},
		{"key":"\#","val":"%23"},
		// {"key":"%","val":"%25"},
		{"key":"\&","val":"%26"},
		// {"key":"\(","val":"%28"},
		// {"key":"\)","val":"%29"},
		{"key":"\+","val":"%2B"},
		// {"key":"\,","val":"%2C"},
		{"key":"\/","val":"%2F"},
		
		{"key":"\@","val":"%40"},
		{"key":"\=","val":"%3D"},
		{"key":"\?","val":"%3F"},
		// {"key":"\.","val":"%2E"},
		// {"key":"\\","val":"%5C"},	==>会导致 莫名多个这\r\n
		{"key":"\|","val":"%7C"},
		{"key":"\r\n","val":"<br%2F>"},
		{"key":"\r","val":"<br%2F>"},
		{"key":"\n","val":"<br%2F>"},
		{"key":"\r\n","val":"<br/>"},
		];
	
	for(let i=0;i<arr.length;i++){
		if(str.indexOf(arr[i].key)>=0){	
			str=StrReplaceAll(str,arr[i].key,arr[i].val);
		}
	}
	
	// str=StrReplaceAll(str,'<br%2F>','\\r\\n');
		
	return str;
}



//检测 校验 json 格式 特殊部分转换
export function JsonStr(str) {
	str = String(str);
	
	let arr=[
		{"key":" ","val":"%20"},
		// {"key":'\"',"val":"%22"},
		{"key":"\#","val":"%23"},
		{"key":"%","val":"%25"},
		{"key":"\&","val":"%26"},
		// {"key":"\(","val":"%28"},
		// {"key":"\)","val":"%29"},
		{"key":"\+","val":"%2B"},
		// {"key":"\,","val":"%2C"},
		{"key":"\/","val":"%2F"},
		
		{"key":"\@","val":"%40"},
		{"key":"\=","val":"%3D"},
		{"key":"\?","val":"%3F"},
		{"key":"\.","val":"%2E"},
		// {"key":"\\","val":"%5C"},
		{"key":"\|","val":"%7C"},
		{"key":"\r\n","val":"<br%2F>"},
		{"key":"\r","val":"<br%2F>"},
		{"key":"\n","val":"<br%2F>"},
		{"key":"\r\n","val":"<br%2F>"},
		];
	
	for(let i=0;i<arr.length;i++){
		if(str.indexOf(arr[i].val)>=0){	
			str=StrReplaceAll(str,arr[i].val,arr[i].key);
		}
	}
	
	// str=StrReplaceAll(str,'<br%2F>','\\r\\n');
		
	return str;
}



// 检查字符串，删除所有不符合Json格式的字符
export function CheckStringToJson(str) {
	str = String(str);
	// console.log(str)
	str=str.replace(/\\n/g, '\\n')  // 替换掉可能的换行符
	      .replace(/\\'/g, "\\'")  // 替换掉可能的单引号
	      .replace(/\\"/g, '\\"')  // 替换掉可能的双引号
	      .replace(/\\&/g, '\\&')  // 替换掉可能的&符号
	      .replace(/\\r/g, '\\r')  // 替换掉可能的回车符
	      .replace(/\\t/g, '\\t')  // 替换掉可能的制表符
	      .replace(/\\b/g, '\\b')  // 替换掉可能的退格符
	      .replace(/\\f/g, '\\f')  // 替换掉可能的换页符
	      .replace(/[\u2028\u2029]/g, '') // 替换掉可能的行分隔符和段分隔符
	      .replace(/[\x00-\x1F\x7F-\x9F]/g, ''); // 替换掉ASCII控制字符
		  
	let arrOld=str.split("");
	// 空字符串、undefined和null值、
	let arrCheck1=[];
	for(let i=0;i<arrOld.length;i++){
		if (arrOld[i]) {
		  // console.log('第'+(i+1)+'个字符是 '+arrOld[i])
		  arrCheck1.push(arrOld[i]);
		}
	}
	// console.log(arrOld)
		
	let arrOK='';
	for(let i=0;i<arrCheck1.length;i++){
		arrOK=arrOK+arrCheck1[i];
	}
	
	return arrOK;
}
